export default __webpack_public_path__ + "static/media/turkish.053c91e3.ico";